import angular from 'angular';

import MonitoringPlanService from './monitoringPlan.service';
import ShopUserService from './shopUser.service';
import ShippingService from './shipping.service';
import ShopCartService from './shopCart.service';

export default angular
    .module('fp:customerportal:shop:common:services', [
    ])
    .service('monitoringPlanService', MonitoringPlanService)
    .service('shopUserService', ShopUserService)
    .service('shopCartService', ShopCartService)
    .service('shippingService', ShippingService);